module.exports = __webpack_public_path__ + "static/dfaae585.tmallClose_4.png";